(function() {
  'use strict';
  
  function initPreorderButton() {
    const preorderButton = document.querySelector('[data-pre-order-button]');
    
    if (!preorderButton) {
      return;
    }
    
    preorderButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('=== PRE-ORDER CLICKED ===');
      
      // Find the actual add-to-cart button (try multiple selectors)
      const addToCartButton = document.querySelector(
        '[data-add-to-cart-button], ' +
        'button[name="add"], ' +
        '.add-to-cart-button, ' +
        '[type="submit"][name="add"], ' +
        'add-to-cart-component button[type="submit"]'
      );
      
      if (!addToCartButton) {
        console.error('Add to cart button not found');
        return;
      }
      
      console.log('Found add-to-cart button:', addToCartButton);
      
      // Store original state
      const wasDisabled = addToCartButton.disabled;
      const originalDisplay = addToCartButton.style.display;
      
      // Temporarily enable and show the button
      addToCartButton.disabled = false;
      addToCartButton.style.display = 'block';
      
      // Disable pre-order button
      this.disabled = true;
      
      // Trigger click on the real add-to-cart button
      setTimeout(() => {
        addToCartButton.click();
        
        // Restore original state
        setTimeout(() => {
          addToCartButton.disabled = wasDisabled;
          addToCartButton.style.display = originalDisplay;
          this.disabled = false;
        }, 100);
      }, 50);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorderButton);
  } else {
    initPreorderButton();
  }
  
  document.addEventListener('shopify:section:load', initPreorderButton);
  
})();
